export default function React_Select() {
  return (
    <div>
      <h1>React_Select Component</h1>
      <p>This is the React_Select tutorial page.</p>
    </div>
  );
}
